import { AccountingSyncStatus } from '../types';
import { palette } from '../palette';

/**
 * Returns the color for accounting sync status based on the status value
 * - SYNCED: white (default success)
 * - FAILED: red (error)
 * - IN_PROGRESS or RETRY_SCHEDULED: orange
 * - PENDING: yellow
 * - Other statuses (NOT_SYNCED, MANUALLY_RECORDED): grey
 */
export const getAccountingSyncStatusColor = (
  status: AccountingSyncStatus | null | undefined,
): string => {
  if (!status) {
    return palette.common.white;
  }

  switch (status) {
    case AccountingSyncStatus.SYNCED:
      return palette.common.white;

    case AccountingSyncStatus.FAILED:
      return palette.error.main; // #FF8663

    case AccountingSyncStatus.IN_PROGRESS:
    case AccountingSyncStatus.RETRY_SCHEDULED:
      return '#FFA500'; // Orange

    case AccountingSyncStatus.PENDING:
      return palette.warning.main; // #FFD900

    case AccountingSyncStatus.NOT_SYNCED:
    case AccountingSyncStatus.MANUALLY_RECORDED:
    default:
      return palette.text.disabled; // #c3c4c8 (grey)
  }
};
